import { useAuth0User } from 'hooks/useAuth0User';
import { isCustomerOps, isHospitalViewer } from 'utils/helpers/permissions.helpers';

export const useIsHospitalViewer = () => {
  const user = useAuth0User();

  return {
    isHospitalViewer: isHospitalViewer(user),
    isCustomerOps: isCustomerOps(user),
  };
};
